
/**
 * Module dependencies.
 */

import { color } from 'src/styles/utils';
import { navElementAttrs } from 'src/components/navbar/nav-element';
import { theme } from 'styled-tools';
import styled from 'styled-components';

/**
 * `FooterActionLink` styled component.
 *
 * The uppercase underlined links of the footer — `Contacte-nos`, `Ver mapa`
 * and `Fazer visita virtual`.
 */

const FooterActionLink = styled.a.attrs(navElementAttrs)`
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: 0;
  color: ${color('white')};
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  letter-spacing: 0.01em;
  line-height: 1.5;
  outline: none;
  padding: 0;
  text-decoration: underline;
  text-transform: uppercase;
  transition: color ${theme('animations.fastTransition')};
  white-space: nowrap;

  &:focus-visible,
  &:hover {
    color: ${color.transparentize('white', 0.7)};
  }
`;

/**
 * Export `FooterActionLink` styled component.
 */

export default FooterActionLink;
